
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Portfolio } from '@/types/portfolio';

export const usePortfolio = (portfolioId: string) => {
  const {
    data: portfolio,
    isLoading,
    error
  } = useQuery({
    queryKey: ['portfolio', portfolioId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('portfolios')
        .select('*')
        .eq('id', portfolioId)
        .single();
      
      if (error) throw error;
      return data as Portfolio;
    },
    enabled: !!portfolioId
  });

  return {
    portfolio,
    isLoading,
    error
  };
};
